import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import Toastr from '../utils/toastr';
import SignalRService from '../../controllers/SignalRService';

class TwoFactorAuth extends Component {

    constructor(props) {
        super(props)

        this.state = {
            code: "",
            loading: false
        }

        this.setCode = this.setCode.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.sendCode = this.sendCode.bind(this);
        this.resendEvent = this.resendEvent.bind(this);
        this.associateResult = this.associateResult.bind(this);
        SignalRService.registerAssociateResultEvent(this.associateResult);
        SignalRService.registerResend(this.resendEvent);
        this.toastrRef = React.createRef();
    }

    setCode(e) {
        e.preventDefault();
        this.setState({
            code: e.target.value
        });
    }

    keyDown = (e) => {
        if (e.keyCode === 13) {
            this.sendCode(e);
        }
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    sendCode = e => {
        this.setLoading(true);
        if (this.state.code !== null && this.state.code.trim() !== "") {
            this.props.setToken(this.state.code);
        } else {
            this.toastrRef.current.setType("warning");
            this.toastrRef.current.setMessage(this.props.t("codecannotbenull"));
            this.toastrRef.current.show();
        }
    }

    resendCode = e => {
        this.setLoading(true);
        this.props.resend();
    }

    associateResult(message) {
        this.setLoading(false);
    }

    resendEvent(res) {
        this.setLoading(false);
        if (res) {
            this.toastrRef.current.setType("success");
            this.toastrRef.current.setMessage(this.props.t("tokensent"));
            this.toastrRef.current.show();
        } else {
            this.toastrRef.current.setType("error");
            this.toastrRef.current.setMessage(this.props.t("error"));
            this.toastrRef.current.show();
        }
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} size="lg" backdrop="static">
                    <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                        <Modal.Header>
                            <Modal.Title><FontAwesomeIcon icon={duotone("lock")} /> {this.props.t("codeequired")}</Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <Form>
                                        <Form.Group className="mb-4">
                                            <Form.Label>{this.props.t("code")}</Form.Label>
                                            <Form.Control type="text" value={this.state.code} onChange={this.setCode} onKeyDown={this.keyDown} autoFocus />
                                            <Form.Text className="text-muted">
                                            </Form.Text>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={this.resendCode}>
                                <FontAwesomeIcon icon={duotone("refresh")} /> {this.props.t("resend")}
                            </Button>
                            <Button variant="primary" onClick={this.sendCode}>
                                <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                            </Button>
                        </Modal.Footer>
                    </BlockUi>
                </Modal>
                <Toastr ref={this.toastrRef} />
            </>)
    }
}

export default withTranslation()(TwoFactorAuth);